














































import ElementQueries from 'css-element-queries';
import Vue from 'vue';
import { mapGetters } from 'vuex';
import Component from 'vue-class-component';
import { Emit, Prop, Watch } from 'vue-property-decorator';
import TagCircle from './tagui/TagCircle.vue';
import BInputLimited from '@/components/input_limited/BInputLimited.vue';
import ColorSlider from '@/components/ColorSlider.vue';
import { PacketType } from '@/models/Packet';
import Timeline from '@/models/Timeline';
import Tag from "@/models/Tag";
import Vector3 from '@/models/Vector3';
import { SendPacket } from '@/networking/SendPacket';
import Mutations from '@/store/mutations';

@Component({
	components: 
	{
		TagCircle,
		BInputLimited,
		ColorSlider
	},
	computed: 
	{
		...mapGetters([
			'checkTimelineWrite'
		]),
	}
})
export default class TagUI extends Vue 
{
	tag : Tag = new Tag();
	interval : any | null = null;

	mounted()
	{
		let _this = this as any;
		if (this.tags != null && _this.checkTimelineWrite())
		{
			this.waitToDisplayTooltip();
		}
		
		this.tag.name = "";
		this.tag.color = Tag.defaultColor(this.timeline.tags.length);
	}

	waitToDisplayTooltip()
	{
		if (this.tags.length == 0)
		{
			this.interval = setTimeout(() => 
			{
				if(this.tags.length == 0 && this.timeline.nodeIDs.length > 0)
				{
					this.$root.$emit('bv::show::tooltip', 'tag-open-btn');
				}
				else
				{
					this.waitToDisplayTooltip();
				}
			}, 10000);
		}
	}

	beforeDestroy()
	{
		if (this.interval != null)
		{
			clearInterval(this.interval);
		}
	}

	tagClick(tag : Tag)
	{
		tag.filtered = !tag.filtered;
		this.$store.commit(Mutations.notifyTagFilterUpdated, null);
		this.$emit('regen-layout');
	}

	clickAddTag()
	{
		this.tag.name = "";
		this.tag.color = Tag.defaultColor(this.timeline.tags.length);
		(this.$refs.addModal as any).show();
	}

	createCategory()
	{
		SendPacket(PacketType.TagCreate, 
		{
			type: 'category',
			name: this.tag.name,
			color: this.tag.color,
			timelineid: this.timeline.id
		});
	}

	get timeline() : Timeline
	{
		return (this.$store.state as any).project.activeTimeline as Timeline;
	}

	get tags() : Tag[]
	{
		return this.timeline.tags;
	}
}
